import React, { Component } from "react";
import { Row, Radio, Spin, Tag, Button, Badge, Tooltip } from "antd";

import { withDomains, RESTExecutor } from "../../lib/domain";
import { showErrorInNotification, overrideHeaderBack } from "../../lib/util";
import ErrorWrapper from "../../lib/error_wrapper";

import ReconciliationMode from "./reconciliation_mode";
import BatchMode from "./batch_mode";
import { Link } from "react-router-dom";
import { BasicHeader } from "../../components/basic_header";
import { TransparentButton } from "../../components/basic_items";
import { COLORS } from "../theme";
import { StorageOutlined } from "@material-ui/icons";

export const OURS_KEY = "ours";
export const THEIRS_KEY = "theirs";

class UnreconciledData extends Component {
  constructor(props) {
    super(props);
    this.reconciler_id = props.match.params.reconciler_id;
    this.source_id = this.props.match.params.source_id;
    this.group_id = this.props.match.params.group_id;

    console.log("HEHEHE", props.match.params);
    this.state = {
      mode: "RECONCILE", //support batch and reconcile
      loading: true,
      source_obj: {},
    };

    this.detail_source = RESTExecutor.detail()
      .forId(this.source_id)
      .config({
        label: "groupsourcedetailbasics",
      })
      .callbacks(
        (success) => {
          // make first id default tab if not done previously
          this.setState({ source_obj: success.result });
        },
        (error) => {}
      )
      .connect(props.domains.usergroups);

    this.get_reconcilers = RESTExecutor.detail()
      .config({
        label: "detail_reconcilers",
      })
      .forId(this.reconciler_id)
      .callbacks(
        (success) => {
          this.setState({ loading: false });
          this.detail_source.forId(this.source_id).execute();
        },
        (error) => {
          this.setState({ loading: false });
        }
      )
      .connect(props.domains.reconciliation);

    this.get_reconcilers.execute();

    console.log("Window val", window.slider_main);
    setTimeout(() => {
      if (window.slider_main) {
        try {
          window.slider_main.changeSliderState(true);
        } catch (e) {
          console.log("Failed to close slider");
        }
      }
    }, 1000);
  }

  render() {
    const { loading, mode, source_obj } = this.state;
    if (loading) {
      return (
        <center>
          <Spin />
        </center>
      );
    }

    let get_reconcilers_resp = this.get_reconcilers.response();
    let get_reconcilers_data = get_reconcilers_resp.result || {};
    let reference = get_reconcilers_data.__references__ || {};
    let exclusions = reference.exclusions || [];
    // exclusions=Array(40).fill({
    //   __references__:{
    //     excluded_group_id:{
    //       name:"Exclusion Name"
    //     }
    //   }
    // })

    return (
      <ErrorWrapper
        error={get_reconcilers_resp}
        onReload={() => {
          this.setState({ loading: true });
          this.get_reconcilers.execute();
        }}
      >
        <div>
          <BasicHeader
            titleType="Reconciler"
            title={get_reconcilers_data.name}
            subtitle={source_obj.group_name}
            subtitleType={"Group"}
            subtitle2={source_obj.source_name}
            subtitleType2={"Source"}
            right={[
              <Link
                to={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/groupedunreconciled`}
              >
                <TransparentButton
                  icon={<StorageOutlined />}
                  label="Matched"
                  hint="View Matched"
                />
              </Link>,
              <Link
                to={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/reconciled`}
              >
                <TransparentButton
                  icon={<StorageOutlined />}
                  label="Reconciled"
                  hint="View Reconciled"
                />
              </Link>,
              <Link
                to={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/pending`}
              >
                <TransparentButton
                  label="Pending"
                  icon={<StorageOutlined />}
                  hint="View Pending"
                />
              </Link>,
            ]}
            bottom={
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  alignItems: "center",
                  flexWrap: "wrap",
                  paddingLeft: 33,
                }}
              >
                <span>Exclusions: &nbsp; </span>
                {exclusions.length === 0 ? (
                  <span style={{ opacity: 0.5 }}>No any exclusions</span>
                ) : (
                  exclusions.map((item) => {
                    let ref = item.__references__ || {};
                    let recon = ref.excluded_group_id || {};
                    return (
                      <Link
                        to={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${item.excluded_group_id}/unreconciled`}
                      >
                        <Tag className="hand-cursor" style={{ margin: 4 }}>
                          {recon.name}
                        </Tag>
                      </Link>
                    );
                  })
                )}
              </div>
            }
          />
          {/* <div style={{height:200,width:'100%',backgroundColor:'red'}}></div> */}
          <div
            className="sticky-content"
            style={{
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              // overflowX:'scroll',
              height: "calc(100vh)",
              paddingLeft: 10,
              paddingRight: 10,
              backgroundColor: COLORS.main_bg_color,
              zIndex: 10,
            }}
          >
            {mode === "RECONCILE" ? (
              <ReconciliationMode
                reconciler_id={this.reconciler_id}
                // group_id={this.group_id}
                source_id={this.source_id}
                key={`${this.reconciler_id}RECONCILE`}
                reconciler={get_reconcilers_data}
                mode={mode}
                onModeChange={(mode) => {
                  this.setState({ mode });
                }}
              />
            ) : (
              <BatchMode
                reconciler_id={this.reconciler_id}
                source_id={this.source_id}
                key={`${this.reconciler_id}BATCH`}
                reconciler={get_reconcilers_data}
                mode={mode}
                onModeChange={(mode) => {
                  this.setState({ mode });
                }}
              />
            )}
          </div>
        </div>
      </ErrorWrapper>
    );
  }

  componentDidMount() {}

  componentWillUnmount() {
    // if (window.slider_main) {
    //   try {
    //     window.slider_main.changeSliderState(false)
    //   } catch (e) {
    //     console.log("Failed to close slider")
    //   }
    // }
  }

  componentDidUpdate = (prevProps) => {
    if (
      this.props.match.params.reconciler_id !==
      prevProps.match.params.reconciler_id
    ) {
      this.reconciler_id = this.props.match.params.reconciler_id;
      this.source_id = this.props.match.params.source_id;
      this.group_id = this.props.match.params.group_id;

      this.setState({
        loading: true,
      });
      setTimeout(() => {
        if (window.slider_main) {
          try {
            window.slider_main.changeSliderState(true);
          } catch (e) {
            console.log("Failed to close slider");
          }
        }
      }, 1000);

      this.get_reconcilers.forId(this.reconciler_id).execute();
      // this.list_reconciled_data.forId(this.reconciler_id).execute()
      // fetch the new product based and set it to the state of the component
    }
  };
}

export default withDomains(UnreconciledData, "reconciliation", "usergroups");
